export default __webpack_public_path__ + "static/media/nox-logo.a9a36761.svg";